module.exports = __webpack_public_path__ + "img/cards.d01553c4.png";